<template>
  <div>

    <!-- header -->
    <app-header></app-header>
    <div class="site-content">
      <!-- main router view -->
      <router-view></router-view>
      <!-- footer -->
      <app-footer></app-footer>
    </div>

  </div>

</template>

<script>
  // import components
  import AppHeader from 'src/components/Header.vue'
  import AppFooter from 'src/components/Footer.vue'

  // Vuex
  import { userAuthenticated } from 'src/vuex/getters.js'
  import { checkUserFromStorage } from 'src/vuex/actions/authActions.js'

  // vuex
  import store from './vuex/store'

  export default {
    store,
    vuex: {
      actions: { checkUserFromStorage },
      getters: { userAuthenticated }
    },
    components: {
      AppHeader, AppFooter
    },
    ready () {
      this.checkUserFromStorage()
    },
    events: {
      'preview-data': function (data) {
        this.$broadcast('preview-data', data)
      }
    }
  }
</script>

<style src="src/assets/sass/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?31c53c3d